export const isExpiring = (endDateTime: string, daysTilExpiry: number) => {
  let expTime = new Date(endDateTime).getTime();
  if(Number.isNaN(expTime))
    return false;
  let delta = expTime - Date.now();

  if(delta < 0){
    //expired
    return true;
  }

  // milliseconds to days (1000 * 60 * 60 * 24)
  let days = Math.floor(delta / 86400000);

  return days <= daysTilExpiry
}

export const dateTimeOffsetToLocal = (dateTime: string) => (new Date(dateTime)).toLocaleDateString()